module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/scss/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/scss/fonts/glyphicons-halflings-regular.ttf
// module chunks = styles